module.exports = __webpack_public_path__ + "img/guirlande-lumineuse.772c938.png";